<ion-card class="purchase-card ion-margin-bottom" *ngIf="cashFund">
  <ion-card-content>
    <div class="totals">
      <ui-fund-cash-payment-status-badge
        class="status-badge"
        [isPaid]="cashFund.isPaid ?? false"
        [isAuthorized]="cashFund.isAuthorized ?? false"
      >
      </ui-fund-cash-payment-status-badge>

      <div *ngIf="cashFund.isAuthorized">
        <div class="total-label">
          {{ 'pages.fund-cash.purchase.confirm.info.totalAuthorized' | translate }}
          <strong>{{ cashFund.authorizedAmount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
        </div>
        <div class="date">
          {{ cashFund.authorizationDate | date: 'dd/MM/YYYY, HH:mm' }}
        </div>
      </div>

      <div *ngIf="cashFund.isPaid">
        <div class="total-label">
          {{ 'pages.fund-cash.purchase.confirm.info.totalPayment' | translate }}
          <strong>{{ cashFund.paymentAmount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
        </div>
        <div class="date">
          {{ cashFund.paymentDate | date: 'dd/MM/YYYY, HH:mm' }}
        </div>
      </div>
    </div>

    <div class="meta ion-margin-bottom">
      <div>{{ cashFund.merchantName }}</div>
    </div>

    <div class="item-tags">
      <div class="tag-icon">
        <ion-icon name="pricetag"></ion-icon>
      </div>
      <div>{{ cashFund.article?.description }} ({{ cashFund.taskName }}/{{ cashFund.subtask?.name }})</div>
      <div class="ml-auto">
        <strong>{{ amount ?? cashFund.authorizedAmount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
      </div>
    </div>

    <ng-container *ngIf="showSplit && (identity$ | async)?.enableCashFundSplit">
      <div class="item-tags" *ngFor="let split of splitRows">
        <div class="tag-icon">
          <ion-icon name="pricetag"></ion-icon>
        </div>
        <div>{{ split.article?.description }} ({{ split.subtask?.taskName }}/{{ split.subtask?.name }})</div>
        <div class="ml-auto">
          <strong>{{ split.amount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
        </div>
      </div>

      <div class="flex justify-content-end">
        <ion-button fill="clear" size="large" (click)="openSplitModalClick.emit()">
          <ion-icon name="git-branch"></ion-icon>
        </ion-button>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
